<template>
  <div>
    <div>
      <div class="form-group">

        <div class="admin-section" v-if="showLogin">
          <login-form class="mb-5" :after-login="afterLogin"></login-form>
          <p class="mb-1">Don't have an account? </p>
          <div class="button-1 inline-block" data-cy="create-account-link" v-on:click="toggleRegister">Create an Account</div>
        </div>

        <div class="admin-section" v-if="showRegister">
          <h3 class="admin-btn">Register</h3>
          <register-form v-if="showRegister"></register-form>
          <div v-on:click="toggleLogin">
            <div class="admin-btn">Login</div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { API_URL } from "../env.js";
import LoginForm from "./LoginForm.vue";
import RegisterForm from "./RegisterForm.vue";

export default {
  data() {
    return {
      showForgotPassword: false,
      showRegister: false,
      showLogin: true
    };
  },

  components: {
    "login-form": LoginForm,
    "register-form": RegisterForm
  },

  computed: {
    user: function() {
      return this.$store.state.notes.user;
    }
  },

  methods: {
    afterLogin () {
        console.log('logged in');
      this.$store.dispatch("aGetBooks");
    },
    toggleRegister() {
      this.showRegister = !this.showRegister;
      this.showLogin = false;
    },

    toggleLogin() {
      this.showLogin = !this.showLogin;
      this.showRegister = false;
    }
  }
};
</script>
